import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const numbnessTremorsWeaknessInExtremitiesLossOfSensation: AnswerPathTreeNode = {
  path: 'numbnessTremorsWeaknessInExtremitiesLossOfSensation',
  children: [
    { path: 'details', nodeId: NodeIds.healthInsuredNumbnessTremorsWeaknessInExtremitiesLossOfSensationDetails },
  ],
};
